import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import React from "react";
import { getCardNumberList } from "sources/books/fuelCards";
import { FormTemplate } from "./templates";

const config = {
    cardIds: {
        // select
        label: "Выберите карты",
        inputProps: { name: "cardIds" },
        url: getCardNumberList,
        isMulti: true,
        propName: "number",
        menuPortalTarget: document.body,
        validators: [requiredField],
        required: true,
    },
};
const initialState = getInitialStateFromConfig(config);

class LinkFuelCards extends FormTemplate {
    sendRequest = (stateData) => this.props.linkCards({ ...this.props.data, ...stateData });

    renderBodyInner = () => {
        const { cardIds } = this.props.config;
        return this.renderSelect(cardIds);
    };
}

const ConfiguredModal = (props) => {
    const initial = { ...initialState };
    if (props.linkedCardIds) {
        initial.cardIds = props.linkedCardIds;
    }
    return <LinkFuelCards {...props} config={config} initialState={initial} />;
};

export default ConfiguredModal;
